import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ClipboardModule } from '@angular/cdk/clipboard';

@Component({
    selector: 'dialog-anchors',
    templateUrl: 'created-dialog.component.html',
    styleUrls: ['./created-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatIconModule, ClipboardModule]
})

export class CampaignCreatedDialog {
    constructor(
        public dialogRef: MatDialogRef<CampaignCreatedDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private snackBar: MatSnackBar
    ) { }
    queryIdCopy() {
        this.snackBar.open('מזהה קמפיין הועתק בהצלחה', 'סגור', { duration: 3000 });
    }
    
}